<script>
import { Codemirror } from 'vue-codemirror';
import { autocompletion } from '@codemirror/autocomplete';
import { customCodeTheme } from '@/utils/theme/rex.code.theme';

export default {
  emits: ['input'],
  components: { Codemirror },
  props: {
    value: {
      type: String,
      default: '',
    },
    lang: {
      type: Object,
      required: true,
    },
    styleObj: {
      type: Object,
      default: () => ({ height: '6rem' }),
    },
    autocompletions: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      defalut: false,
    },
  },
  setup(props) {
    function customCompletions(context) {
      let before = context.matchBefore(/\w+/);
      // If completion wasn't explicitly started and there
      // is no word before the cursor, don't open completions.
      if (!context.explicit && !before) return null;
      return {
        from: before ? before.from : context.pos,
        options: props.autocompletions,
        validFor: /^\w*$/,
      };
    }
    const extensions = [
      props.lang,
      autocompletion({ override: [customCompletions] }),
      customCodeTheme,
    ];
    return {
      extensions,
    };
  },
  mounted() {
    const elements = document.getElementsByClassName('cm-content');
    for (let i = 0; i < elements?.length; i++) {
      elements[i].setAttribute('data-enable-grammarly', false);
      elements[i].setAttribute('data-gramm', false);
      elements[i].setAttribute('data-gramm_editor', false);
    }
  },
};
</script>

<template>
  <div>
    <Codemirror
      :modelValue="value"
      :placeholder="placeholder"
      :style="styleObj"
      :autofocus="true"
      :indentWithTab="true"
      :tabSize="2"
      :extensions="extensions"
      @change="(event) => $emit('input', event)"
      class="rex-code-editor-comp"
      :disabled="disabled"
    />
  </div>
</template>

<style lang="scss" scoped>
.rex-code-editor-comp {
  text-align: left;
}
</style>
